import * as React from 'react';
import styled from 'styled-components';
import { MuiChip } from '../../../Chip/MuiChip';
import { AutocompleteChipProps, Components } from '../../types';
import Typography from '../../../Typography/Typography';
import { RichTextPresenter } from './RichTextPresenter';

export const Chips: NonNullable<Components['Chips']> = ({
  selectedOptions,
  getTagProps,
  visibleElementsWhenSelected,
  limitChips = 999,
  isFocused,
  onBeforeChipClick,
  endText
}): JSX.Element => {
  const limit = isFocused ? 999 : limitChips;

  return (
    <StyledDiv>
      {selectedOptions.slice(0, limit).map((currentOption, index) => {
        const props = getTagProps({ index }) as AutocompleteChipProps;
        const icon = visibleElementsWhenSelected?.icon && currentOption.icon ? currentOption.icon : null;
        return (
          <MuiChip
            key={currentOption?.label || index}
            style={{
              marginTop: 1,
              marginRight: 8
            }}
            label={
              <RichTextPresenter
                selectedOption={currentOption}
                visibleElementsWhenSelected={{ ...visibleElementsWhenSelected, icon: false }}
                variant="small"
                style={{ height: 24 }}
              />
            }
            icon={icon}
            onClickCapture={onBeforeChipClick}
            onDelete={
              !props.disabled
                ? () => {
                    props.onDelete();
                  }
                : undefined
            }
            size="small"
          />
        );
      })}
      {!!endText && <StyledTypography>{endText}</StyledTypography>}
    </StyledDiv>
  );
};
const StyledDiv = styled.div`
  max-height: 150px;
  overflow-x: hidden;
  overflow-y: auto;
  .uds-chip {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.colorOnSurfaceVariant};
  white-space: nowrap;
  display: inline-flex;

  .body1 {
    font-size: 13px;
    line-height: 23px;
  }
`;
